import { useState } from "react";
import { FormGroup, FormInput, FormLabel } from "src/styled";

interface Props {
  align?: string;
  autoFocus?: boolean;
  disabled?: boolean;
  hasError?: boolean;
  label?: string;
  margin?: string;
  max?: number | string;
  min?: number | string;
  onChange?: (value: any) => void;
  placeholder?: string;
  preventNumberExponent?: boolean;
  step?: string;
  type?: string;
  value?: number | string | boolean;
  width?: string;
}

const UnconnectedInput = ({
  value,
  preventNumberExponent,
  width,
  placeholder,
  label,
  disabled,
  margin,
  align,
  hasError,
  onChange,
  ...props
}: Props) => {
  const [stateValue, setStateValue] = useState<
    string | number | boolean | undefined
  >(value);

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setStateValue(value);

    onChange && onChange(value);
  };

  const preventDefault = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const keyForE = "E";

    if (preventNumberExponent && event.key === keyForE) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  return (
    <FormGroup width={width} margin={margin} hasValue={stateValue}>
      {!!label && <FormLabel>{label}</FormLabel>}

      <FormInput
        {...props}
        align={align}
        hasError={hasError}
        disabled={disabled}
        placeholder={placeholder || ""}
        onChange={handleOnChange}
        onKeyDown={preventDefault}
      />
    </FormGroup>
  );
};

export default UnconnectedInput;
